import React, { useEffect } from "react";
import { Button } from "primereact/button";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import CouponsTable from "./CouponsTable";
import { getCoupons } from "../../store/AsyncMethods/CouponMethod";
import { usePermissions } from "../../permissions/PermissionContext";

export default function CouponsMain() {
  const { canOpen } = usePermissions();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.AuthReducer);

  useEffect(() => {
    if (user) {
      dispatch(getCoupons());
    }
  }, []);

  return (
    <div className="mx-3">
      <div className="flex justify-end">
        {canOpen("/add-coupon") && (
          <Button
            label="Add Coupon"
            icon="pi pi-plus"
            className="p-primary-btn"
            onClick={() => navigate("/add-coupon")}
          />
        )}
      </div>

      <div className="my-4">
        <CouponsTable />
      </div>
    </div>
  );
}
